import React, { useState, useEffect } from 'react';
import { Button, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import axios from 'axios';
import { useStore } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import API from '../../../create/api';

const useStyles = makeStyles((theme) => ({
  table: {
    // minWidth: 700,
  },
  fromControl: {
    width: '100%',
  },
}));

export default function PickupRequestTable() {
  const store: any = useStore();
  const classes = useStyles();

  const [ridersFilter, setRidersFilter]: [Array<{ name: string; id: number }>, any] = useState([]);
  const [pickupRequests, setPickupRequests] = useState([]);
  const [paymentRequests, setPaymentRequests] = useState([]);

  async function updatePickupRequest(id: number, data: object) {
    await axios
      .put(`${process.env.REACT_APP_API_SERVER}/pickup-requests/${id}`, data, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then(() => {
        fetchRequests();
      });
  }

  async function updatePaymentRequest(id: number, data: object) {
    await axios
      .put(`${process.env.REACT_APP_API_SERVER}/payment-requests/${id}`, data, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then(() => {
        fetchRequests();
      });
  }

  function fetchRequests() {
    axios
      .get(`${process.env.REACT_APP_API_SERVER}/pickup-requests/active`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        setPickupRequests(res.data ?? []);
      });

    axios
      .get(`${process.env.REACT_APP_API_SERVER}/payment-requests/active`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        setPaymentRequests(res.data ?? []);
      });
  }

  useEffect(() => {
    API.getAll(`${process.env.REACT_APP_API_SERVER}/riders`).then((riders) => {
      setRidersFilter(riders);
      fetchRequests();
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(fetchRequests, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <h4 style={{ marginBottom: '20px' }}>Active Pickup Requests</h4>
      <Table className={classes.table} aria-label="pickup requests table" padding="checkbox">
        <TableHead>
          <TableRow>
            <TableCell>Company</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Rider</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pickupRequests.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row?.company?.name}</TableCell>
              <TableCell>{row?.date}</TableCell>
              <TableCell>{row?.status}</TableCell>
              <TableCell>
                <Select
                  className={classes.fromControl}
                  value={row?.rider?.id}
                  onChange={(e) => {
                    const rider: any = e.target.value ?? '';
                    updatePickupRequest(row.id, {
                      rider,
                      status: 'RIDER_ASSIGNED',
                    });
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {ridersFilter.map((v: any, index: number) => (
                    <MenuItem key={`${v.name}-${index}-Select-item`} value={v.id}>
                      {v.id}:{v.name}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell>
                <Button
                  onClick={async () => {
                    await updatePickupRequest(row.id, { status: 'DONE' });
                  }}
                  variant="contained"
                  color="primary"
                >
                  DONE
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div style={{ marginTop: '40px' }}>
        <h4 style={{ marginBottom: '20px' }}>Active Payment Requests</h4>
        <Table className={classes.table} aria-label="payment requests table" padding="checkbox">
          <TableHead>
            <TableRow>
              <TableCell>Company</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Method</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentRequests.map((row: any) => (
              <TableRow key={row.id}>
                <TableCell>{row?.company?.name}</TableCell>
                <TableCell>{row?.date}</TableCell>
                <TableCell>{row?.status}</TableCell>
                <TableCell>{row?.method}</TableCell>
                <TableCell>
                  <Button
                    onClick={async () => {
                      await updatePaymentRequest(row.id, { status: 'DONE' });
                    }}
                    variant="contained"
                    color="primary"
                  >
                    DONE
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
